module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"change_delivery_success":"Запрос на изменение адреса доставки отправлен. Ваш менеджер свяжется с Вами в течение 24 часов"},"en":{"change_delivery_success":"Your delivery address request has been sent. Our manager will contact you in 24 hours"}}')
  delete Component.options._Ctor
}
